import { IUser, IUserProfile } from '../Models/IUser';
import { ApiService, IBlankResponse } from '../_services/ApiService';

export class UserProfileService extends ApiService {
    protected basePath = 'users';

    public async updateProfile(updates: Partial<IUserProfile>, file: File | null, shouldRemovePhoto: boolean): Promise<boolean> {
        let data: {} | FormData = updates;
        if (file) {
            data = new FormData();
            Object.keys(updates).forEach(key => {
                const value = (updates as any)[key];
                if (value) {
                    const formValue = typeof value === 'string' ? value : JSON.stringify(value);
                    (data as FormData).append(key, formValue);
                }
            });
            (data as FormData).append('image', file);
        } else {
            const profileUrl = shouldRemovePhoto ? { profile_image_url: null } : {};
            data = { ...data, ...profileUrl };
        }

        const response: IBlankResponse = await this.putRequest(data);
        return response.success;
    }

    public async getUserByID(userID: number): Promise<IUser> {
        return this.getSubPath(userID.toString());
    }
}



// WEBPACK FOOTER //
// ./src/Services/UserProfileService.ts